import { TimelineEntry } from '../types';

export const initialTimelineEntries: TimelineEntry[] = [
  {
    id: '1',
    event_date: '2026-03-20',
    title: '첫 캠핑',
    content: '조금 추웠지만 불멍하면서 도란도란 이야기 나눈 게 너무 좋았어.',
    image_urls: ['https://images.unsplash.com/photo-1504280390367-361c6d9f38f4?q=80&w=800&auto=format&fit=crop'],
    location: '가평 캠핑장',
    tags: ['#캠핑', '#불멍', '#여행'],
  },
  {
    id: '2',
    event_date: '2026-04-15',
    title: '벚꽃 놀이',
    content: '올해 벚꽃은 유난히 예뻤다. 사람이 많았지만 너랑 함께라서 행복했어.',
    image_urls: ['https://images.unsplash.com/photo-1522383225653-ed111181a951?q=80&w=800&auto=format&fit=crop'],
    location: '여의도 한강공원',
    tags: ['#벚꽃', '#데이트', '#봄'],
  },
  {
    id: '3',
    event_date: '2026-05-10',
    title: '한강 피크닉',
    content: '날씨가 너무 좋아서 돗자리 펴고 누워있기만 해도 힐링이었어.',
    image_urls: ['https://images.unsplash.com/photo-1517486808906-6ca8b3f04846?q=80&w=800&auto=format&fit=crop'],
    location: '반포 한강지구',
    tags: ['#피크닉', '#한강', '#치맥'],
  },
];

export const getTimelineWithCounts = (entries: TimelineEntry[]) => {
  return [...entries]
    .sort((a, b) => new Date(a.event_date).getTime() - new Date(b.event_date).getTime())
    .map((entry, index) => ({
      ...entry,
      meetingCount: index + 1
    }));
};
